const colors = {
  black: {
    default: "#000000",
  },
  white: {
    default: "#FFFFFF",
  },
  gray: {
    50: "#F0F0FA",
    100: "#E2E1EC",
    200: "#C6C6D0",
    300: "#AAAAB4",
    400: "#8F909A",
    500: "#767680",
    600: "#5D5E67",
    700: "#45464F",
  },
  blue: {
    50: "#EFF0FF",
    100: "#DCE1FF",
    200: "#8FA7FF",
    300: "#3557BC",
    400: "#00287D",
    500: "#00164E",
  },
  cyan: {
    50: "#79F4D2",
    400: "#2C9E83",
    600: "#004C51",
  },
  green: {
    50: "#95FA86",
    400: "#42A43D",
    600: "#006E0F",
  },
  red: {
    50: "#FFDAD6",
    400: "#FF5449",
    600: "#93000A",
  },
  orange: {
    50: "#FFDEA9",
    400: "#BC8711",
    600: "#7D5800",
  },
  pink: {
    50: "#FFD9E2",
    400: "#F15A93",
    600: "#AF2560",
  },
};

export default colors;
